import { Store, select } from '@ngrx/store';
import { LoadingOrganizationsAction, selectOrganizations } from '@app/access-management/state';
import { needsLoading, GoAction } from '@app/core';
import { take, filter, map } from 'rxjs/operators';
import { SelectOrganizationAction } from './organization-details/organization-details.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var shouldLoadOrganizations = function (organizations) { return needsLoading(organizations); };
var ɵ0 = shouldLoadOrganizations;
var hasOrganizationsState = function (organizations) { return !needsLoading(organizations); };
var ɵ1 = hasOrganizationsState;
var OrganizationsFacadeService = /** @class */ (function () {
    function OrganizationsFacadeService(store) {
        this.store = store;
        this.loadableOrganizations$ = this.store.pipe(select(selectOrganizations));
        this.organizations$ = this.loadableOrganizations$.pipe(filter(hasOrganizationsState), map(function (organizationList) { return organizationList.data; }));
    }
    OrganizationsFacadeService.prototype.initialize = function () {
        var _this = this;
        this.loadableOrganizations$
            .pipe(take(1), filter(shouldLoadOrganizations))
            .subscribe(function () { return _this.store.dispatch(new LoadingOrganizationsAction()); });
    };
    OrganizationsFacadeService.prototype.selectOrganization = function (organization) {
        this.store.dispatch(new SelectOrganizationAction(organization));
        this.store.dispatch(new GoAction(['/iam/organizations', organization.id]));
    };
    OrganizationsFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function OrganizationsFacadeService_Factory() { return new OrganizationsFacadeService(i0.inject(i1.Store)); }, token: OrganizationsFacadeService, providedIn: "root" });
    return OrganizationsFacadeService;
}());
export { OrganizationsFacadeService };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// ./src/app/access-management/state/organizations.facade.ts.pre-build-optimizer.js